import { List, Map } from "immutable";

import AssigneeSectionStat from "../../../../models/Assignee/SectionStat";
import TeacherAssignment from "../../../../models/TeacherAssignment";
import {
  getAssignee,
  getAssigneeIndividualSectionStats,
  getAssignmentAssigneesWithSections
} from "./teacherAssignment";

export type Condition = (stat?: AssigneeSectionStat) => boolean;

export function getSmartAssignmentSectionsFromConditions(
  state: TeacherAssignment,
  conditions: Condition[]
) {
  const usersSections = getAssignmentAssigneesWithSections(state);

  return Map<string, List<string>>(
    usersSections.reduce((reduction, sectionIds, userId) => {
      const assignee = getAssignee(state, userId);
      if (!assignee) return reduction;

      const sectionsToReset = sectionIds.filter((sectionId: string) => {
        const stat = getAssigneeIndividualSectionStats(
          state,
          userId,
          sectionId
        );

        return conditions.some(condition => condition(stat));
      });

      if (sectionsToReset.size > 0) {
        return {
          ...reduction,
          [userId]: sectionsToReset
        };
      }

      return reduction;
    }, {})
  );
}
